import type { IFirstTouch } from "~/feature/attribution/type";
import type { ISignUpUnsafeMetadata } from "~/feature/auth/type";

const toCampaignMetadata = (
  signupCampaign: string | null
): ISignUpUnsafeMetadata => (signupCampaign ? { signupCampaign } : {});

export const buildSignUpUnsafeMetadata = (
  signupCampaign: string | null,
  firstTouch: IFirstTouch | null
): ISignUpUnsafeMetadata | undefined => {
  if (!signupCampaign && !firstTouch) {
    return undefined;
  }

  return { ...firstTouch, ...toCampaignMetadata(signupCampaign) };
};
